"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyMessage = void 0;
class EmptyMessage {
    writeTo(cell) {
        // Nothing to do
    }
}
exports.EmptyMessage = EmptyMessage;
